import { useCallback } from 'react'

import type { NotificationFormType } from '@/notificationForms'
import type { TestEmailNotificationFormValues, TestValues } from '../types'

import { testNotificationMessage } from '@/features/domain/territory'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

import { generateTestNotificationPayload } from './generateTestNotificationPayload'
import { useController } from './useController'

export function useOnSubmit(notification: NotificationFormType, values: TestValues) {
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const isUnMounted = useIsUnmounted()
  const { update } = useController()

  return useCallback(
    async (formValues: TestEmailNotificationFormValues) => {
      try {
        const payload = generateTestNotificationPayload(notification, formValues.email, values)

        const thunkResult = await dispatch(testNotificationMessage(payload))

        if (!testNotificationMessage.fulfilled.match(thunkResult)) {
          throw new Error(thunkResult.payload?.message ?? 'Internal error')
        }

        update({ status: 'success' })

        if (isUnMounted()) return
      } catch (error) {
        toast.error(error.message)
        update({ status: 'error' })
      }
    },
    [dispatch, toast, notification, values, isUnMounted, update],
  )
}
